const encodeItemNumber = (itemNumber: string): string => (
  itemNumber.replace('.', '%2E')
);

export default encodeItemNumber;
